declare namespace $ {

	export class $mol_icon_email extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=email.view.tree.d.ts.map